import gql from 'graphql-tag';
export const UPDATE_COMPANY = gql `
  mutation UpdateCompany($input: UpdateCompanyInput!, $updateRule: UpdateRule) {
    updateCompany(input: $input, updateRule: $updateRule) {
      company {
        id
        tenantId
        createdAt
        companyName
        contactName
        countryId
        state
        email
        personas
        blackList
        locale
        billing {
          firstName
          lastName
          currency
          identifierType
          identifier
          fiscalEntity
          zipCode
          city
          address
          phone
          editable
          billingPeriod
        }
      }
    }
  }
`;
//# sourceMappingURL=update.company.js.map